module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/series/en-GB/img_series-111.png";